// Dokümantasyon ortak yardımcıları: dosya ikonu, boyut, blob ile açma/indirme
import axios from 'axios';
import { FileText, FileSpreadsheet, FileImage, Presentation, File } from 'lucide-react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.webp';
export const errText = (e) => (typeof e.response?.data?.detail === 'string' ? e.response.data.detail : e.response?.data?.detail?.[0]?.msg?.replace('Value error, ', '') || 'İşlem başarısız');
export const fileSize = (n) => (n > 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
export const dt = (s) => (s ? new Date(s).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' }) : '-');

const ICONS = [
  [/pdf/, FileText, 'text-rose-600 bg-rose-50'],
  [/sheet|excel/, FileSpreadsheet, 'text-emerald-600 bg-emerald-50'],
  [/presentation|powerpoint/, Presentation, 'text-orange-600 bg-orange-50'],
  [/word/, FileText, 'text-blue-600 bg-blue-50'],
  [/image/, FileImage, 'text-violet-600 bg-violet-50'],
];

export const FileBadge = ({ type, className = 'h-11 w-11' }) => {
  const [, Icon, cls] = ICONS.find(([re]) => re.test(type || '')) || [null, File, 'text-slate-600 bg-slate-100'];
  return <span className={`${className} ${cls} shrink-0 rounded-lg flex items-center justify-center`}><Icon className="h-5 w-5" /></span>;
};

export const openFile = async (url, name, download) => {
  const blob = (await axios.get(url, { responseType: 'blob' })).data;
  const href = URL.createObjectURL(blob);
  if (download) Object.assign(document.createElement('a'), { href, download: name }).click();
  else window.open(href, '_blank', 'noopener');
  setTimeout(() => URL.revokeObjectURL(href), 60000);
};
